import { PaymentMethodOptions } from '@40seas/entities/charges';
import { FromSchema, ZodDate } from '@40seas/entities/common';
import { CurrencyExchange } from '@40seas/entities/currency-exchange';
import { Fee, FeeSchema, PaymentOption, PaymentOptionSchema, PaymentOptionWithFee, PaymentOptionWithFeeSchema } from '@40seas/models';
import { z } from 'zod';
import { CheckoutFee, CheckoutFeeSchema } from './checkout.fee';

export const CheckoutResultSchema = z
    .object({
        totalFee: z.number().optional(),
        total: z.number().optional(),
        dueDate: ZodDate.optional(),
        paymentDate: ZodDate.optional(),
        paymentOption: PaymentOptionSchema.optional(), // TODO: FS-5663 remove field
        paymentOptionFee: FeeSchema.optional(), // TODO: FS-5663 remove field
        paymentMethodId: z.string().optional(),
        currencyExchange: z.any().optional(), // TODO add currency exchange schema
        feeDefinition: z.string().optional(), // TODO: FS-5663 remove field
        fees: z.array(CheckoutFeeSchema).optional(), // TODO: FS-5663 remove field
        paymentMethodOptions: z.record(z.string(), z.any()).optional(),
        paymentOptionWithFee: PaymentOptionWithFeeSchema.optional(),
        totalDiscount: z.number().optional(),
    })
    .strict();

export class CheckoutResult extends FromSchema(CheckoutResultSchema) {
    totalFee?: number;
    total?: number;
    dueDate?: Date;
    paymentMethodId?: string;
    currencyExchange?: CurrencyExchange;
    paymentOption?: PaymentOption; // TODO: FS-5663 remove field
    paymentOptionFee?: Fee; // TODO: FS-5663 remove field
    feeDefinition?: string; // TODO: FS-5663 remove field
    paymentDate?: Date;
    fees?: CheckoutFee[]; // TODO: FS-5663 remove field
    paymentOptionWithFee?: PaymentOptionWithFee;
    paymentMethodOptions?: PaymentMethodOptions;
    totalDiscount?: number;
}
